import styled from 'styled-components'

export const Tooltip = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: #000;
  position: relative;

  .tooltip {
    display: none;
  }

  .tooltip:hover {
    display: block;
    position: absolute;
    background-color: #fff;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);
    border: 1px solid #e5e5e5;
    border-radius: 4px;
    padding: 16px;
    z-index: 999;
    left: 0;
  }

  .label {
    cursor: pointer;
  }

  //quando der hover na class label o tooltip vai aparecer
  .label:hover + .tooltip {
    display: block;
    position: absolute;
    background-color: #fff;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);
    border: 1px solid #e5e5e5;
    border-radius: 4px;
    padding: 16px;
    z-index: 999;
    left: 0;
  }

  .tooltip-content {
  }
`
